export default __webpack_public_path__ + "static/media/thumb01_flyer@2x.1360cf34.png";